import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_23: FaireProductEntity = {
  token: "legacy_prod_abbott-23",
  type: "product",
  name: "Monet 024",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/247e9e2f06678d92048ab8323d04a1ddb9776d189801fda553f447d8ec433aee.jpeg",
  priceDollars: 20,
  subcategory: "Art & Prints",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_wall-decor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
